module.exports = __webpack_public_path__ + "img/auth-pass.9a8f204d.svg";